import { useCallback } from 'react';
import { listarDispositivos } from '../api/dispositivos.js';
import { useConsulta } from '../api/useConsulta.js';

/**
 * Quantos aparelhos estão bloqueados agora — o selo vermelho da barra lateral.
 *
 * Vinha de `dados-exemplo/navegacao.ts` com o valor fixo `2`. Isso passou a
 * ser mentira no dia em que a tela de Dispositivos começou a consumir a API:
 * o selo dizia "2 problemas" e a tabela ao lado mostrava zero. Selo é alerta,
 * e alerta que não corresponde a nada ensina o supervisor a ignorá-lo.
 *
 * Pede `tamanho: 1` porque só o `total` interessa; a lista vem do servidor
 * filtrada, e não há contagem feita aqui.
 *
 * `null` enquanto não se sabe (ou se a consulta falhou): o selo simplesmente
 * não aparece, em vez de aparecer zerado — "zero bloqueados" é uma afirmação,
 * e ela não foi verificada.
 */
export function useDispositivosBloqueados(): number | null {
  const contar = useCallback(
    () => listarDispositivos({ status: 'Bloqueado', pagina: 1, tamanho: 1 }),
    [],
  );

  return useConsulta(contar).dados?.total ?? null;
}
